var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "comparison-ctn"
  }, [_vm.isMobile ? _c('div', {
    staticClass: "comparison-stack"
  }, [_c('div', {
    staticClass: "stack-plans"
  }, [_c('div', {
    staticClass: "stack-plan stack-plan--accent"
  }, [_c('span', {
    staticClass: "plan-header-name"
  }, [_vm._v(_vm._s(_vm.dppTextileName))]), _c('span', {
    staticClass: "plan-header-price"
  }, [_vm.loading ? _c('v-progress-circular', {
    attrs: {
      "size": "20",
      "indeterminate": "",
      "color": "primary",
      "role": "status",
      "aria-label": _vm.loadingLabel
    }
  }) : [_c('span', {
    staticClass: "plan-header-amount"
  }, [_vm._v(_vm._s(_vm.dppTextilePrice))]), _vm.dppTextilePricePeriod ? _c('span', {
    staticClass: "plan-header-period"
  }, [_vm._v(_vm._s(_vm.dppTextilePricePeriod))]) : _vm._e()]], 2), _c('v-expand-transition', [_vm.hasPriceNote ? _c('span', {
    staticClass: "content-hint plan-header-note"
  }, [_vm._v(_vm._s(_vm.dppTextilePriceNote))]) : _vm._e()]), _c('v-btn', {
    attrs: {
      "block": "",
      "depressed": "",
      "color": "primary",
      "disabled": _vm.dppTextileCtaDisabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('dpp-textile-cta');
      }
    }
  }, [_vm._v(_vm._s(_vm.dppTextileCtaLabel))])], 1), _c('div', {
    staticClass: "stack-plan"
  }, [_c('span', {
    staticClass: "plan-header-name"
  }, [_vm._v(_vm._s(_vm.enterpriseName))]), _c('span', {
    staticClass: "plan-header-price plan-header-price--custom"
  }, [_c('span', {
    staticClass: "plan-header-custom"
  }, [_vm._v(_vm._s(_vm.enterprisePrice))])]), _c('v-btn', {
    attrs: {
      "block": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('enterprise-cta');
      }
    }
  }, [_vm._v(_vm._s(_vm.enterpriseCtaLabel))])], 1)]), _vm._l(_vm.groups, function (group) {
    return _c('section', {
      key: group.title,
      staticClass: "stack-group"
    }, [_c('h6', {
      staticClass: "group-title"
    }, [_vm._v(_vm._s(group.title))]), _c('dl', {
      staticClass: "stack-rows"
    }, _vm._l(group.rows, function (row) {
      return _c('div', {
        key: row.label,
        staticClass: "stack-row"
      }, [_c('dt', {
        staticClass: "stack-feature"
      }, [_vm._v(_vm._s(row.label))]), _c('dd', {
        staticClass: "stack-value"
      }, [_c('span', {
        staticClass: "stack-plan-label"
      }, [_vm._v(_vm._s(_vm.dppTextileName))]), _c('plan-feature-value', {
        attrs: {
          "value": row.dppTextile,
          "includedLabel": _vm.includedLabel,
          "notIncludedLabel": _vm.notIncludedLabel
        }
      })], 1), _c('dd', {
        staticClass: "stack-value"
      }, [_c('span', {
        staticClass: "stack-plan-label"
      }, [_vm._v(_vm._s(_vm.enterpriseName))]), _c('plan-feature-value', {
        attrs: {
          "value": row.enterprise,
          "includedLabel": _vm.includedLabel,
          "notIncludedLabel": _vm.notIncludedLabel
        }
      })], 1)]);
    }), 0)]);
  })], 2) : _c('div', {
    staticClass: "comparison-scroll",
    attrs: {
      "tabindex": "0",
      "role": "region",
      "aria-label": _vm.caption
    }
  }, [_c('table', {
    staticClass: "comparison"
  }, [_c('caption', {
    staticClass: "d-sr-only"
  }, [_vm._v(_vm._s(_vm.caption))]), _vm._m(0), _c('thead', [_c('tr', [_c('th', {
    staticClass: "header-spacer",
    attrs: {
      "scope": "col",
      "aria-hidden": "true"
    }
  }), _c('th', {
    staticClass: "plan-header plan-header--accent",
    attrs: {
      "scope": "col",
      "aria-label": _vm.dppTextileName
    }
  }, [_c('span', {
    staticClass: "plan-header-name"
  }, [_vm._v(_vm._s(_vm.dppTextileName))]), _c('span', {
    staticClass: "plan-header-price"
  }, [_vm.loading ? _c('v-progress-circular', {
    attrs: {
      "size": "20",
      "indeterminate": "",
      "color": "primary",
      "role": "status",
      "aria-label": _vm.loadingLabel
    }
  }) : [_c('span', {
    staticClass: "plan-header-amount"
  }, [_vm._v(_vm._s(_vm.dppTextilePrice))]), _vm.dppTextilePricePeriod ? _c('span', {
    staticClass: "plan-header-period"
  }, [_vm._v(_vm._s(_vm.dppTextilePricePeriod))]) : _vm._e()]], 2), _c('v-expand-transition', [_vm.hasPriceNote ? _c('span', {
    staticClass: "content-hint plan-header-note"
  }, [_vm._v(_vm._s(_vm.dppTextilePriceNote))]) : _vm._e()]), _c('v-btn', {
    attrs: {
      "depressed": "",
      "color": "primary",
      "disabled": _vm.dppTextileCtaDisabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('dpp-textile-cta');
      }
    }
  }, [_vm._v(_vm._s(_vm.dppTextileCtaLabel))])], 1), _c('th', {
    staticClass: "plan-header",
    attrs: {
      "scope": "col",
      "aria-label": _vm.enterpriseName
    }
  }, [_c('span', {
    staticClass: "plan-header-name"
  }, [_vm._v(_vm._s(_vm.enterpriseName))]), _c('span', {
    staticClass: "plan-header-price plan-header-price--custom"
  }, [_c('span', {
    staticClass: "plan-header-custom"
  }, [_vm._v(_vm._s(_vm.enterprisePrice))])]), _c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('enterprise-cta');
      }
    }
  }, [_vm._v(_vm._s(_vm.enterpriseCtaLabel))])], 1)])]), _vm._l(_vm.groups, function (group) {
    return _c('tbody', {
      key: group.title
    }, [_c('tr', [_c('th', {
      staticClass: "group-title",
      attrs: {
        "colspan": "3",
        "scope": "rowgroup"
      }
    }, [_vm._v(_vm._s(group.title))])]), _vm._l(group.rows, function (row) {
      return _c('tr', {
        key: row.label,
        staticClass: "feature-row"
      }, [_c('th', {
        staticClass: "feature-label",
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(row.label))]), _c('td', {
        staticClass: "feature-value"
      }, [_c('plan-feature-value', {
        attrs: {
          "value": row.dppTextile,
          "includedLabel": _vm.includedLabel,
          "notIncludedLabel": _vm.notIncludedLabel
        }
      })], 1), _c('td', {
        staticClass: "feature-value"
      }, [_c('plan-feature-value', {
        attrs: {
          "value": row.enterprise,
          "includedLabel": _vm.includedLabel,
          "notIncludedLabel": _vm.notIncludedLabel
        }
      })], 1)]);
    })], 2);
  })], 2)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('colgroup', [_c('col', {
    staticClass: "col-feature"
  }), _c('col', {
    staticClass: "col-plan"
  }), _c('col', {
    staticClass: "col-plan"
  })]);

}]

export { render, staticRenderFns }